/*eslint-disable*/export const messages=JSON.parse("{\"icon.title.sailboat\":[\"Två fåglar och en segelbåt på vatten\"]}");